import { ENDPOINT, requestOptions } from '../utils/settings'
import { PLOT_AREA_GLOBAL_SETTINGS } from '../../src/AdminSettings'

export async function updateGlobalConfig(args: PLOT_AREA_GLOBAL_SETTINGS): Promise<PLOT_AREA_GLOBAL_SETTINGS> {
    try {
        const formdata = new FormData()

        formdata.append('MAX_TICKS_PER_CROP', String(args.MAX_TICKS_PER_CROP))
        formdata.append('RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD', String(args.RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD))

        const myHeaders = new Headers()
        myHeaders.append('Accept', 'application/json')

        const properties = await fetch(`${ENDPOINT}/pdf/global-config`, {
            ...requestOptions,
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        }).then(response => response.json())

        return properties
    } catch (error) {
        console.error(error)
        return args
    }
}

export async function getGlobalConfig(): Promise<PLOT_AREA_GLOBAL_SETTINGS> {
    const properties = await fetch(`${ENDPOINT}/pdf/global-config`, requestOptions).then(response => response.json())
    return properties
}
